import React from "react";
import VerticalMenuWithContentToggle$ from "@deosite/components-new/VerticalMenuWithContentToggle";
import CheckboxSelectable from "../selectables/Checkbox";

const VerticalMenuWithContentToggle = props => {
  const propsExt = {
    ...props,
    checkboxSelectable: <CheckboxSelectable />
  };
  return <VerticalMenuWithContentToggle$ {...propsExt} />;
};

export default VerticalMenuWithContentToggle;
